import ViewportTracker from '../../lib/ViewportTracker';
import Debouncer from '../../lib/Debouncer';
import ProductSearchMobile from './ProductSearchMobile';
import ProductSearchDesktop from './ProductSearchDesktop';
import ProductSearchAbstract from './ProductSearchAbstract';

export default class ProductSearch {
	private responsiveState: string;
	private searchInterface: ProductSearchAbstract;

	constructor() {
		if (!document.getElementsByClassName('productSearch').length)
			return;

		this.init();
		window.addEventListener('resize', new Debouncer(this.resizeHandler).run, false);
	}

	/**
	 * Runs only on switch from mobile to desktop
	 */
	private init(): void {
		if (ViewportTracker.below('productSearchLinear')) {
			this.responsiveState = 'mobile';

			this.searchInterface = new ProductSearchMobile();
		} else if (!ViewportTracker.below('productSearchLinear') && this.responsiveState !== 'desktop') {
			this.responsiveState = 'desktop';

			this.searchInterface = new ProductSearchDesktop();
		}
	}

	private resizeHandler = (event: Event): void => {
		const changeToMobile: boolean = ViewportTracker.below('productSearchLinear') && this.responsiveState !== 'mobile';
		const changeToDesktop: boolean = !ViewportTracker.below('productSearchLinear') && this.responsiveState !== 'desktop';
		if (changeToDesktop || changeToMobile) {
			window.location.reload();
		}
	}
}
